<template>
  <v-layout
    justify-left
    wrap>
    <v-flex md6>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.application.application'| translate }} - {{ applicationData.Application.Id }} ({{ applicationStatus }})</h3>
        </div>

        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.application.claimant'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.ClaimantName }}</v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md6>{{ 'krita.application.registryid'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.ClaimantRegistryId | kennitala }}</v-flex>
          </v-layout>
          <!--<v-layout-->
          <!--v-if="applicationData.Application.Status === 1 || applicationData.Application.Status === 2 || applicationData.Application.Status === 4"-->
          <!--row>-->
          <!--<v-flex md6>{{ 'krita.application.adminoffer'| translate }}</v-flex>-->
          <!--<v-flex-->
          <!--md6-->
          <!--class="text-md-right">{{ applicationData.Application.OfferAdmin }}</v-flex>-->
          <!--</v-layout>-->
          <!--<v-layout-->
          <!--v-if="applicationData.Application.Status === 1 || applicationData.Application.Status === 2 || applicationData.Application.Status === 4 || applicationData.Application.OfferDate !==null"-->
          <!--row>-->
          <!--<v-flex md6>{{ 'krita.application.dateoffer'| translate }}</v-flex>-->
          <!--<v-flex-->
          <!--md6-->
          <!--class="text-md-right">{{ applicationData.Application.OfferDate | date }}</v-flex>-->
          <!--</v-layout>-->
          <v-layout 
            v-if="applicationData.Application.Status === 1" 
            row>
            <v-flex md6>{{ 'krita.application.expirationdate'| translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.Application.ExpiryDate | dateTime }}</v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>
    <v-flex md6>
      <div class="v-card v-sheet theme--light">
        <div class="v-card__title v-card__title--primary">
          <h3 class="heading-4 mb-0">{{ 'krita.application.amountsonapp' | translate }}</h3>
        </div>
        <div class="v-card__text">
          <hr>
          <v-layout row>
            <v-flex md6>{{ 'krita.application.originalcapital' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.Application.TotalAmount | amount }}</v-flex>
          </v-layout>

          <v-layout 
            v-if="false" 
            row>
            <v-flex md6>{{ 'krita.application.totalofferamount' | translate }}</v-flex>
            <v-flex
              v-if="applicationData.Application.Status !== 0"
              md6
              class="text-md-right">{{ applicationData.OfferAmount | amount }}</v-flex>

            <v-flex
              v-if="applicationData.Application.Status === 0"
              md6
              class="text-md-right">0 kr.</v-flex>
          </v-layout>

          <hr v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1">

          <v-layout
            v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1"
            row>
            <v-flex md6>{{ 'krita.application.initialtransfer' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.InitialTransfer | amount }}</v-flex>
          </v-layout>

          <v-layout
            v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1"
            row>
            <v-flex md6>{{ 'krita.application.feeamount' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.Application.FeeAmount | amount }}</v-flex>
          </v-layout>

          <v-layout
            v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1"
            row>
            <v-flex md6>{{ 'krita.application.buffer' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.ApplicationBuffer | amount }}</v-flex>
          </v-layout>

          <v-layout
            v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2"
            row>
            <v-flex md6>{{ 'krita.application.refactored' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.Refactored | amount }}</v-flex>
          </v-layout>

          <v-layout
            v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2"
            row>
            <v-flex md6>{{ 'krita.application.initafterref' | translate }}</v-flex>
            <v-flex
              md6
              class="text-md-right">{{ applicationData.TransferAfterRefactor | amount }}</v-flex>
          </v-layout>

          <hr v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1 && applicationData.ReservedForRefactoring !== 0">

          <v-layout
            v-if="!(applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.ReservedForRefactoring === 0)"
            row>
            <v-flex md6>{{ 'krita.application.reservedforref' | translate }}</v-flex>
            <v-flex
              v-if="applicationData.Application.Status !== 0"
              md6
              class="text-md-right">{{ applicationData.ReservedForRefactoring | amount }}</v-flex>
          </v-layout>

          <hr v-if="applicationData.Application.Status === 4 || applicationData.Application.Status === 2 || applicationData.Application.Status === 1 && applicationData.ReservedForRefactoring !== 0">

          <v-layout
            v-if="!(applicationData.Application.Status === 4 || applicationData.Application.Status === 2)"
            row>
            <v-flex md6>{{ 'krita.application.initwithoutrefres' | translate }}</v-flex>
            <v-flex
              v-if="applicationData.Application.Status !== 0"
              md6
              class="text-md-right">{{ applicationData.TransferAfterRefactorReserved | amount }}</v-flex>

            <v-flex
              v-if="applicationData.Application.Status === 0"
              md6
              class="text-md-right">0 kr.</v-flex>
          </v-layout>

          <v-layout
            v-if="applicationData.Application.Status === 0 || applicationData.Application.Status === 1"
            row>
            <v-flex
              md12
              class="text-md-right">
              <module-button
                :disabled="approveBtnDisable"
                :values="applicationApproveBtn"
                :dialog="processingApproveApplicationRequest"
                :loading="processingApproveApplicationRequest"
                @confirmClick="$emit('approveApplicationOffer')"/>
              <module-button
                :loading="processingCancelApplicationRequest"
                :dialog="processingCancelApplicationRequest"
                :values="applicationCancelBtn"
                @confirmClick="$emit('cancelApplicationOffer')"/>
            </v-flex>
          </v-layout>

        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import ModuleButton from '../controllers/ModuleButton.vue';
import EnumIterator from '../helper/EnumIterator'
    export default {
        name: "ApplicationDetailInfo",
        components: {ModuleButton},
        props: ['applicationData', 'processingCancelApplicationRequest', 'processingApproveApplicationRequest'],
        computed: {
            approveBtnDisable ()
            {
                if (this.applicationData.Application.Status === 1)
                {
                    return false;
                }
                return true;
            },
            applicationCancelBtn()
            {
                let cancelBtn  =
                    {
                        icon:'',
                        headline: this.$t('krita.application.cancelapplication'),
                        confirmBtnText: this.$t('krita.application.cancelapplication'),
                        openBtnText: this.$t('krita.application.modal.cancel'),
                        text: this.$t('krita.application.modal.text'),
                        openBtnColor:'warning',
                        confirmBtnColor:'warning'
                    };
                return cancelBtn;
            },
            applicationApproveBtn()
            {
                let approveBtn  =
                    {
                        icon:'',
                        headline: this.$t('krita.application.approve'),
                        confirmBtnText: this.$t('krita.application.approve'),
                        openBtnText: this.$t('krita.application.approve'),
                        text: this.$t('krita.application.approveapplication'),
                        openBtnColor:'primary',
                        confirmBtnColor:'primary'
                    };
                return approveBtn;
            },
            applicationStatus ()
            {
              let self = this;

              return self.$t(EnumIterator.processApplicationStatus(self.applicationData.Application.Status));
            },
        },
    }
</script>

<style scoped>

</style>
